<template>
<div class="cf padding_bottom10">
	<Page :total="total" @on-change="pagechange" :page-size="size" :current="current" class-name="frt margin_top"></Page>
</div>
</template>

<script>
	export default{
        props: ["total","pagechange","size","current"]
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Page.vue